/* eslint-disable @typescript-eslint/no-empty-function */
import { DietIdEnum, DietModeType } from '@front-activerse/common-components';
import { createContext } from 'react';
import { dietSettings, stepConfigItem } from '../types';
interface DietType {
  id: number;
  value: DietIdEnum;
  optionTitle: string;
  optionDescription: string;
  renderCondition?: (values: dietSettings) => boolean;
}

interface DietMode {
  value: DietModeType;
  optionTitle: string;
  optionDescription: string;
  disableCondition?: (values: dietSettings) => boolean;
}

interface StepContextType {
  currentStep: string;
  currentMainStep: string;
  schema: stepConfigItem[];
  prevStep: string;
  nextStep: string;
  isLastStep: boolean;
  shouldBackendValidate: boolean;
  dietTypes: DietType[];
  dietLevels: DietType[];
  dietModes?: DietMode[];
  generateDiet: (values: any) => void;
  saveUserData: (values: any) => void;
  validateDietSettings: (values: any) => void;
}

const StepContext = createContext<StepContextType>({
  currentStep: '',
  currentMainStep: '',
  schema: [
    {
      id: '',
      slug: '',
    },
  ],
  prevStep: '',
  nextStep: '',
  isLastStep: false,
  shouldBackendValidate: false,
  dietTypes: [
    {
      id: 0,
      value: DietIdEnum.DIET_ID_CLASSIC,
      optionTitle: '',
      optionDescription: '',
    },
  ],
  dietLevels: [
    {
      id: 0,
      value: DietIdEnum.DIET_ID_CLASSIC,
      optionTitle: '',
      optionDescription: '',
    },
  ],
  dietModes: [
    {
      value: DietModeType.slimming,
      optionTitle: '',
      optionDescription: '',
    },
  ],
  generateDiet: (values: any) => {},
  saveUserData: (values: any) => {},
  validateDietSettings: (values: any) => {},
});

export default StepContext;
